<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="workUnit.pkId ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="workUnit"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item v-if="workUnit.pkId" label="工作单元编号">
        <el-input v-model="workUnit.workUnitNo" disabled placeholder="请输入工作单元编号"/>
      </el-form-item>
      <el-form-item label="工作单元名称" prop="workUnitName">
        <el-input v-model="workUnit.workUnitName" placeholder="请输入工作单元名称"/>
      </el-form-item>
      <el-form-item label="所属工作中心" prop="workCenterName">
        <el-input v-model="workUnit.workCenterName" readonly placeholder="请选择所属工作中心">
          <el-button slot="append" @click="$refs.selectWorkCenter.open()">选择</el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" style="margin-bottom:5px" @click="$refs.employeeSelect.open()">添加操作员</el-button>
    </div>
    <el-table
        border
        stripe
        :data="workUnit.employeeVOS">
      <el-table-column label="员工姓名" prop="employeeName" align="center" width="150"/>
      <el-table-column label="员工编号" prop="employeeNO" align="center"/>
      <el-table-column label="操作" align="center" width="80">
        <template v-slot="scope">
          <el-button type="danger" @click="deleteRow(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter"/>
    <employee-select ref="employeeSelect" @select="employeeSelect"/>
  </el-dialog>
</template>

<script>
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";  
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  export default {
    name: "WorkUnitEdit",
    components: { WorkCenterSelect,EmployeeSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        workUnit: {
          pkId: 0,
          workUnitNo: "",
          workUnitName: "",
          workCenterId: "",
          workCenterName: "",
          employeeVOS:[],
        },
        ruleValidate: {
          workCenterName: { required: true, message: "请选择所属工作中心", trigger: "change" },
          workUnitName: { required: true, message: "请输入工作单元名称", trigger: "blur" },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.workUnit.pkId = row.pkId;
          this.getData();
        }
      },

      // 根据工作单元id查询详细信息
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `workUnits/${this.workUnit.pkId}`)
          .then((resp) => {
            if (resp.success) {
              this.workUnit = Object.assign(this.workUnit, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "workUnits", this.workUnit)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.workUnit.pkId > 0) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },

      // 选择工作中心
      onSelectWorkCenter(row) {
        this.workUnit.workCenterId = row.pkId;
        this.workUnit.workCenterName = row.workCenterName;
      },

      //添加操作员
      employeeSelect(row) {
        console.log(row);
        let arr = this.workUnit.employeeVOS.filter(item=> item.employeeID === row.employeeID);
        if(arr.length) {
          this.$message.error("请勿重复添加操作员");
        }else{
          this.workUnit.employeeVOS.push(row);
        }
      },

      deleteRow(index) {
        this.workUnit.employeeVOS.splice(index,1);
      },
    },
  };
</script>
